const HomeSection = ({ title, sx, children }) => {
    return (
        <section className={`home-section home-section-${title}`} style={{ ...sx, padding: '16px', boxSizing: "border-box" }}>
            {children}
        </section>
    )
}

export default HomeSection;